export default "__VITE_ASSET__9bf163f7__"